// utils/mapHttpErrorToMessage.js

export function mapHttpErrorToMessage(err, t) {
    const translate =
        typeof t === "function"
            ? t
            : (key, options) => options?.defaultValue ?? key;

    const status = err?.response?.status ?? 418;

    const errorMap = {
        401: {
            title: translate("error.401.title", { defaultValue: "Unauthorized" }),
            message: translate("error.401.message", { defaultValue: "You are not authorized." }),
            status: 401,
        },
        403: {
            title: translate("error.403.title", { defaultValue: "Forbidden" }),
            message: translate("error.403.message", { defaultValue: "You do not have access." }),
            status: 403,
        },
        404: {
            title: translate("error.404.title", { defaultValue: "Not found" }),
            message: translate("error.404.message", { defaultValue: "The requested resource was not found." }),
            status: 404,
        },
        500: {
            title: translate("error.500.title", { defaultValue: "Server error" }),
            message: translate("error.500.message", { defaultValue: "An internal server error occurred." }),
            status: 500,
        },
        503: {
            title: translate("error.503.title", { defaultValue: "Service unavailable" }),
            message: translate("error.503.message", { defaultValue: "The service is temporarily unavailable." }),
            status: 503,
        },
        418: {
            title: translate("error.418.title", { defaultValue: "Error" }),
            message: translate("error.418.message", { defaultValue: "Something went wrong." }),
            status: 418,
        },
    };

    return errorMap[status] || {
        title: translate("error.error_title2", { defaultValue: "Error" }),
        message: translate("error.error_message", { defaultValue: "Something went wrong." }),
        status,
    };
}
